'use client'

import type { Data } from '@repo/strapi-types'
import { use } from 'react'
import type { AppLocale } from '@/types/general'

type ChangelogEntry = Data.ContentType<'api::change-log.change-log'>

// Kept per locale, so that use() gets the same promise on every render
const changelogIndexRequests = new Map<AppLocale, Promise<ChangelogEntry[]>>()

function fetchChangelogIndex(locale: AppLocale) {
  const request =
    changelogIndexRequests.get(locale) ??
    fetch(`/data/changelog/${locale}/entries.json`)
      .then((response) => (response.ok ? (response.json() as Promise<ChangelogEntry[]>) : []))
      .catch(() => [])

  changelogIndexRequests.set(locale, request)
  return request
}

/**
 * Loads all changelog entries from the static `/data/changelog/{locale}/entries.json` index. Suspends until it's loaded.
 */
const useChangelogIndex = ({ locale }: { locale: AppLocale }) => use(fetchChangelogIndex(locale))

export default useChangelogIndex
